import { render } from "./UpdateTeams.vue?vue&type=template&id=e7076c28"
import script from "./UpdateTeams.vue?vue&type=script&lang=js"
export * from "./UpdateTeams.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__